import { createRef } from 'react';
import SwissPostQuery from "../query/SwissPost.query";
import { fetchQuery } from 'Util/Request';

export class MyAccountAddressFormContainerPlugin {
    containerFunctions = (originalMember, instance) => ({
        ...originalMember,
        onStreet0Change: this.onStreet0Change.bind(instance),
        onFirstnameChange: this.onFirstnameChange.bind(instance),
        onLastnameChange: this.onLastnameChange.bind(instance),
        onZipcodeChange: (field) => this.onFieldChangeProxy.call(instance, field, originalMember.onZipcodeChange),
        onCityChange: (field) => this.onFieldChangeProxy.call(instance, field, originalMember.onCityChange),
    });

    onFieldChangeProxy(field, callback) {
        callback(field);
        this.validateAddress();
    }

    onStreet0Change(field) {
        this.setState({ currentStreet0: field.target.value });
        this.validateAddress();
    }

    onFirstnameChange(field) {
        this.setState({ currentFirstname: field.target.value });
        this.validateAddress();
    }

    onLastnameChange(field) {
        this.setState({ currentLastname: field.target.value });
        this.validateAddress();
    }
}

const { containerFunctions, fieldMap } = new MyAccountAddressFormContainerPlugin();

const getAddressPayload = (formElements) => {
    const {
        firstname,
        lastname,
        country_id,
        street_0,
        street,
        city,
        postcode
    } = formElements;

    if (country_id.value === 'CH') {
        if (firstname.value && lastname.value && (street_0 || street) && city.value && postcode.value) {
            return {
                firstname: firstname.value,
                lastname: lastname.value,
                street: [street_0 ? street_0.value : street.value],
                city: city.value,
                postcode: postcode.value
            }
        }
    }
    return false;
}

const validateAddress = async (args, callback, instance) => {
    clearTimeout(instance.validationDebounce);
    if (instance.formRef.current) {
        console.log(instance.formRef.current.elements);
        const formElements = instance.formRef.current.elements;
        const addressPayload = getAddressPayload(formElements);
        if (addressPayload) {
            instance.validationDebounce = setTimeout(() => instance.getAddressValidation(addressPayload), 300);
        } else {
            instance.setState({
                validationState: null
            })
        }
    }
}

const getAddressValidation = async (args, callback, instance) => {
    const [addressPayload] = args;
    const { validateShippingAddress: validateCode} = await fetchQuery(SwissPostQuery.getValidateShippingAddressQuery(addressPayload));
    const validationState = getAddressValidationState(validateCode);
    instance.setState({
        validationState
    });
}

const getAddressValidationState = (code) => {
    switch(code) {
        case "CERTIFIED":
        case "DOMICILE_CERTIFIED":
            return "CERTIFIED";
        case "USABLE":
        case "FIXED":
            return "VALID";
        case "UNUSABLE":
        case "COMPROMISED":
            return "NOT VALID"
        case "ERROR":
        default:
            return "ERROR";
    }
}

const state = (originalMember) => ({
    ...originalMember,
    currentStreet0: '',
    currentFirstname: '',
    currentLastname: '',
    validationState: null
});

const formRef = createRef('');

const __construct = (args, callback, instance) => {
    callback(...args);
    instance.formRef = formRef;
    instance.validationDebounce = null;
}

const containerProps = (args, callback, instance) => {
    return {
        ...callback(),
        formRef: instance.formRef,
        validationState: instance.state.validationState
    }
}

export default {
    'Component/MyAccountAddressForm/Container': {
        'member-property': {
            containerFunctions,
            state
        },
        'member-function': {
            getAddressValidation,
            validateAddress,
            __construct,
            containerProps
        }
    }
}
